module.exports = __webpack_public_path__ + "static/img/baccarat2_esp.c93c6a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/baccarat2_esp.png
// module id = SDa+
// module chunks = 1